import { Component, Input, OnInit, NgModule, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/zip';
import * as _ from 'underscore';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { ReportService } from '../../services/report/report.service';
import { Orientation } from './orientation';
import { ReportRoutingModule } from './report.routing.module';
import { Page } from './page';
import { Element } from './element';
import { Product } from './product';
import { Scale } from './scale';
import { Size } from './size';
import { Margin } from './margin';
import { TextAlign } from './textAlign';
import { FontFamily } from './fontFamily';
import { FontSize } from './fontSize';
import { Color } from './color';
import { ReportElementSize } from './reportElementSize';
import { ReportElementType } from './reportElementType';

declare const $: any;
declare const window: any;

@Component({
  selector: 'reportcomp',
  template: `
  <div class="card">
    <div class="card-header bg-pr-color white-text">
        <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color d-none d-md-block"
            (click)="displayLeftBar()"><i class="fa fa-list-alt"></i></button>
        <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color d-none d-md-block"
            (click)="search()"><i class="fa fa-search"></i></button>
        <div class="btn-group float-left report-btn-group d-none d-md-block" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="decPage()"><i class="fa fa-chevron-left"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="incPage()"><i class="fa fa-chevron-right"></i></button>
        </div>
        <label class="report-toolbar-label float-left d-none d-md-block"> Page : </label>
        <input [(ngModel)]="page" class="report-toolbar-input float-left d-none d-md-block" />
        <label class="report-toolbar-label float-left d-none d-md-block"> sur {{ pages.length }}</label>
        <div class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="decScale()"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="incScale()"><i class="fa fa-plus"></i></button>
        </div>
        <!--<select [(ngModel)]="scale" class="mdb-select float-left">
          <option *ngFor="let item of scales" value="{{ item.id }}">{{ item.caption }}</option>
        </select>-->
        <!--<button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" dnd-draggable
            [dropZones]="['page']"><i class="fa fa-font"></i></button>-->
        <div *ngIf="model" class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="addLabelElement()"><i class="fa fa-font"></i></button>
            <!--<button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="addFieldElement()"><i class="fa fa-database"></i></button>-->
            <ng-template #popTable><div *ngFor="let rowIdx of [0,1,2,3,4,5,6,7]" class="row"><button type="button" *ngFor="let colIdx of [0,1,2,3,4,5,6,7]" class="table-report-size" [ngClass]="getTableBtnClass(rowIdx, colIdx)" (mouseover)="over(rowIdx, colIdx)" (click)="addTableElement(rowIdx, colIdx)"></button></div></ng-template>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngbPopover]="popTable" placement="bottom" #popOverTable="ngbPopover"><i class="fa fa-table"></i></button>
            <!--<button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" data-toggle="popover" title="" data-placement="bottom"><i class="fa fa-table"></i></button>-->
            <!--<button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="addTableElement()"><i class="fa fa-table"></i></button>-->
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="addImageElement()"><i class="fa fa-photo"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="addChartElement()"><i class="fa fa-bar-chart"></i></button>
        </div>
        <div *ngIf="!model && id>0" class="btn-group float-right report-btn-group" role="group">
            <!--<button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" (click)="print()"><i class="fa fa-print"></i></button>-->
            <a type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" href="http://ftp.odusseuserp.org/download/{{ id }}.pdf"><i class="fa fa-download"></i></a>
        </div>
    </div>
    <div *ngIf="selectedElement != null && model" class="card-header bg-pr-color white-text">
        <select [(ngModel)]="selectedElement.fontfamily_id" class="mdb-select mdb-select-fontfamily float-left">
          <option *ngFor="let item of fontFamilies" value="{{ item.id }}">{{ item.name }}</option>
        </select>
        <select [(ngModel)]="selectedElement.fontsize_id" class="mdb-select mdb-select-fontsize float-left">
          <option *ngFor="let item of fontSizes" value="{{ item.id }}">{{ item.value }}</option>
        </select>
        <div class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isBold()}"
                (click)="boldElement()"><i class="fa fa-bold"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isItalic()}"
                (click)="italicElement()"><i class="fa fa-italic"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isUnderline()}"
                (click)="underlineElement()"><i class="fa fa-underline"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isLineThrough()}"
                (click)="lineThroughElement()"><i class="fa fa-strikethrough"></i></button>
        </div>
        <div class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isFontColored()}"
                (click)="colorFont()"><i class="fa fa-font"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color"><i class="fa fa-caret-down"></i></button>
        </div>
        <div class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isBackgroundColored()}"
                (click)="colorBackground()"><i class="fa fa-font"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color"><i class="fa fa-caret-down"></i></button>
        </div>
        <div class="btn-group float-left report-btn-group" role="group">
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isAlignElement(1)}"
                (click)="alignElement(1)"><i class="fa fa-align-left"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isAlignElement(2)}"
                (click)="alignElement(2)"><i class="fa fa-align-center"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isAlignElement(3)}"
                (click)="alignElement(3)"><i class="fa fa-align-right"></i></button>
            <button type="button" class="btn btn-default navbar-btn float-left waves-effect waves-light bg-pr-color" [ngClass]="{'active':isAlignElement(4)}"
                (click)="alignElement(4)"><i class="fa fa-align-justify"></i></button>
        </div>
        <select [(ngModel)]="selectedElement.reportelementsize_id" class="mdb-select mdb-select-reportelementsize float-left">
          <option *ngFor="let item of reportElementSizes" value="{{ item.id }}">{{ item.name }}</option>
        </select>
        <div class="float-right text-right">
            <div class="btn-group report-btn-group" role="group">
                <button type="button" class="btn btn-default navbar-btn waves-effect waves-light bg-pr-color" (click)="decIndex()"><i class="fa fa-arrow-up"></i></button>
                <button type="button" class="btn btn-default navbar-btn waves-effect waves-light bg-pr-color" (click)="incIndex()"><i class="fa fa-arrow-down"></i></button>
            </div>
            <button type="button" class="btn btn-default navbar-btn waves-effect waves-light red" (click)="deleteElement()"><i class="fa fa-minus"></i></button>
        </div>
    </div>
    <div class="card-block report-scroll">
        <div class="container" style="text-align: center;">
            <spinner *ngIf="loading"></spinner>
        </div>
        <div *ngIf="!loading">
            <div class="report-page" id="{{ page.name }}" *ngFor="let page of pages" [style.width.mm]="getWidth()" [style.height.mm]="getHeight()"
                [style.padding-top.mm]="getPaddingTop()" [style.padding-bottom.mm]="getPaddingBottom()" [style.padding-left.mm]="getPaddingLeft()"
                [style.padding-right.mm]="getPaddingRight()" dnd-droppable (onDropSuccess)="dropElement($event)" [dropZones]="['page']">
                <div class="row">
                    <div class="report-element" [ngClass]="getReportElementSizeClass(element)" *ngFor="let element of reportService.reportElements"
                        [style.text-align]="getTextAlign(element)" [style.font-weight]="getFontWeight(element)"
                        [style.font-style]="getFontStyle(element)" [style.text-decoration]="getTextDecoration(element)" [style.font-family]="getFontFamily(element)"
                        [style.color]="getFontColor(element)" [style.background-color]="getBackgroundColor(element)" [style.font-size.px]="getFontSize(element)"
                        [ngSwitch]="getReportElementTypeUid(element.reportelementtype_id)">
                        <div *ngSwitchCase="1">
                            <span *ngIf="element != selectedElement" (click)="selectElement(element)">{{ element.value }}</span>
                            <input [(ngModel)]="element.value" *ngIf="element == selectedElement" class="report-selected-element" />
                        </div>
                        <table class="table-report-element" *ngSwitchCase="3">
                            <tr *ngFor="let rowElement of element.elements" class="row-report-element">
                                <td *ngFor="let colElement of rowElement.elements" class="col-report-element">
                                    <span *ngIf="colElement != selectedElement" (click)="selectElement(colElement)">{{ colElement.value }}</span>
                                    <input [(ngModel)]="colElement.value" *ngIf="colElement == selectedElement" class="report-selected-element" />
                                </td>
                            </tr>
                        </table>
                        <img *ngSwitchCase="6" [src]="element.value" (click)="selectElement(element)"/>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="accordion" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="card">
        <div class="card-header" role="tab" id="headingOne">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                <h5 class="mb-0">
                    Collapsible Group Item #1 <i class="fa fa-angle-down rotate-icon"></i>
                </h5>
            </a>
        </div>
        <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
            <div class="card-block">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
                helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                heard of them accusamus labore sustainable VHS.
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-header" role="tab" id="headingTwo">
            <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                <h5 class="mb-0">
                    Collapsible Group Item #2 <i class="fa fa-angle-down rotate-icon"></i>
                </h5>
            </a>
        </div>
        <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
            <div class="card-block">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
                helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                heard of them accusamus labore sustainable VHS.
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-header" role="tab" id="headingThree">
            <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                <h5 class="mb-0">
                    Collapsible Group Item #3 <i class="fa fa-angle-down rotate-icon"></i>
                </h5>
            </a>
        </div>
        <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree">
            <div class="card-block">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
                helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                heard of them accusamus labore sustainable VHS.
            </div>
        </div>
    </div>
  </div>-->
    </div>
  </div>`,
  styles: [`.report-toolbar {
    height: 49px;
    background: #222;
    padding: 2px;
    border-bottom: 1px solid #9d9d9d;
    border-radius: 4px 4px 0px 0px;
  }
  .report-toolbar .form-group {
    margin-right : 0px;
    margin-left  : 0px;
  }
  .report-toolbar-label {
    color: #FFFFFF;
      margin: .5rem .2rem;
  }
  .report-toolbar-input {
    width: 70px !important;
  }
  .report-toolbar-button {
      color: #9d9d9d;
      background-color: #222;
      border-color: #9d9d9d;
  }
  .report-toolbar-button:hover,.report-toolbar-button:focus {
      color: #FFFFFF;
      background-color: #222;
      border-color: #FFFFFF;
  }
  .report-container {
    overflow: auto;
    background: #222;
    position: absolute;
      top: 49px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      border-radius: 0px 0px 4px 4px;
  }
  .report-page {
      background: #FFFFFF;
      border: 1px solid #9d9d9d;
      margin: 2px auto 2px auto;
      position: relative;
  }
  .report-element {
      padding: 0px;
      cursor: pointer;
  }
  .report-scroll {
      overflow: scroll;
      padding: 0px;
      min-height: 60vh;
  }
  .navbar-btn {
      margin-top: 0px;
      margin-bottom: 0px;
      padding: .6rem 1rem;
  }
  .report-btn-group {
      margin: 0px 6px;
  }
  .report-selected-element {
      width: 100%;
      border-radius: 0px;
      text-align: inherit;
      font-weight: inherit;
      font-style: inherit;
      font-family: inherit;
      font-size: inherit;
      color: inherit;
      background-color: inherit;
      text-decoration: inherit;
      border: none;
  }
  .table-report-element {
      width: 100%;
      border: 1px solid black;
  }
  .row-report-element {
      border: 1px solid black;
  }
  .col-report-element {
      border: 1px solid black;
  }
  .table-report-size {
      width: 16px;
      height: 16px;
      border: 1px solid black;
  }
  .table-report-size.active {
      background-color: #007bff;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class ReportCompComponent {

  @Input() public id: number = 0;
  public scales: Scale[] = new Array<Scale>();
  public scale: number = 0;
  @Input() public marginId: number = 111;
  public margins: Margin[] = new Array<Margin>();
  @Input() public sizeId: number = 111;
  public sizes: Size[] = new Array<Size>();
  @Input() public orientationId: number = 111;
  public orientations: Orientation[] = new Array<Orientation>();
  public pages: Page[] = new Array<Page>();
  public page: number = 1;
  public loading: boolean = false;
  @Input() public model: boolean = false;
  @Input() public reporttypeId: number = 111;
  @Input() public parentId: number = 111;
  public selectedElement: Element;
  public textAligns: TextAlign[] = new Array<TextAlign>();
  public fontFamilies: FontFamily[] = new Array<FontFamily>();
  public fontSizes: FontSize[] = new Array<FontSize>();
  public reportElementTypes: ReportElementType[] = new Array<ReportElementType>();
  public reportElementSizes: ReportElementSize[] = new Array<ReportElementSize>();
  public colors: Color[] = new Array<Color>();
  public lastFontColor: Color;
  public lastBackgroundColor: Color;
  public lastFontSizeId: number = 111;
  public lastFontFamilyId: number = 111;
  public lastReportElementSizeId: number = 111;
  public lastTextAlignId: number = 111;
  public lastBold: boolean = false;
  public lastItalic: boolean = false;
  public lastUnderline: boolean = false;
  public lastLineThrough: boolean = false;
  public colOver: number = 0;
  public rowOver: number = 0;

  constructor(public reportService: ReportService) {
  }

  ngOnInit(): void {
    this.loading = true;
    Observable.zip(
      this.reportService.getScales(),
      this.reportService.getMargins(),
      this.reportService.getSizes(),
      this.reportService.getOrientations(),
      this.reportService.getTextAligns(),
      this.reportService.getFontFamilies(),
      this.reportService.getFontSizes(),
      this.reportService.getColors(),
      this.reportService.getReportElementTypes(),
      this.reportService.getReportElementSizes()
    )
      .subscribe(([scales, margins, sizes, orientations, textAligns, fontFamilies, fontSizes, colors, reportElementTypes, reportElementSizes]) => {
        this.scales = scales;
        this.margins = margins;
        this.sizes = sizes;
        this.orientations = orientations;
        this.textAligns = textAligns;
        this.fontFamilies = fontFamilies;
        this.fontSizes = fontSizes;
        this.colors = colors;
        this.reportElementTypes = reportElementTypes;
        this.reportElementSizes = reportElementSizes;
      },
      (err:any) => {
        console.log(err);
      },
      () => {
        this.loading = false;
      });
    if (this.model) {
      this.pages.push(new Page('Page1', 'Page 1', this.marginId, this.sizeId, this.orientationId));
      if (this.id > 0) {
        this.reportService.getReportTypeElements(this.id).subscribe((elements) => {
          this.reportService.reportElements = elements;
        }, (error) => {
          console.log(error);
        });
      } else {
        this.reportService.reportElements = new Array<any>();
      }
    } else {
      if (this.id > 0) {
        console.log('REPORT ID: ' + this.id);
        this.reportService.getReportType(this.reporttypeId).subscribe((reporttype) => {
          this.sizeId = reporttype.reportsize_id;
          this.orientationId = reporttype.reportorientation_id;
          this.marginId = reporttype.reportmargin_id;
          this.pages.push(new Page('Page1', 'Page 1', reporttype.reportmargin_id, reporttype.reportsize_id, reporttype.reportorientation_id));
        }, (error) => {
          console.log(error);
        });
        this.reportService.getReportElements(this.id).subscribe((elements) => {
          this.reportService.reportElements = elements;
        }, (error) => {
          console.log(error);
        });
      } else {
        console.log('New report with reporttype_id: ' + this.reporttypeId);
        this.reportService.getReportType(this.reporttypeId).subscribe((reporttype) => {
          this.sizeId = reporttype.reportsize_id;
          this.orientationId = reporttype.reportorientation_id;
          this.marginId = reporttype.reportmargin_id;
          this.pages.push(new Page('Page1', 'Page 1', reporttype.reportmargin_id, reporttype.reportsize_id, reporttype.reportorientation_id));
        }, (error) => {
          console.log(error);
        });
        this.reportService.getReportTypeElements(this.reporttypeId).subscribe((elements) => {
          elements.forEach((element: any) => {
            delete element.id;
            element['parent_id'] = 0;
            this.reportService.reportElements.push(element);
          });
          this.reportService.reportElements = elements;
          this.loadDatas();
        }, (error) => {
          console.log(error);
        });
      }
    }
    //this.pages.push(new Page("Page1", "Page 1", 0, 0));
  }
  /*ngAfterViewInit(): void {
    setTimeout(() => {
      $('[data-toggle="popover"]').popover({
        content: this.tableSelector(),
        html: true
      });
    });
  }
  public tableSelector(): string {
    let selector: string = '';
    for (let i = 0; i<=7; i++) {
      selector = selector + '<button type="button" class="table-report-size" (click)="addTableElement(' + i + ')">';
    }
    return selector;
  }*/
  public loadDatas(): void {
    this.reportService.reportElements.forEach((element) => {
      const str = element.value;
      const re = /\[(.*?)\]/g;
      let res: any;
      while (res = re.exec(str)) {
        if (res[1] === 'date') {
          const pattern: string = res[0];
          this.reportService.reportElements[element.index].value = str.replace(pattern, new Date().toLocaleDateString());
        }
        else if (res[1] === 'heure') {
          const pattern: string = res[0];
          this.reportService.reportElements[element.index].value = str.replace(pattern, new Date().toLocaleTimeString());
        }
        else {
          const path: string[] = res[1].split('.');
          const pattern: string = res[0];
          this.reportService.getElementValue(res[1], this.parentId).subscribe(
            (result) => {
              this.reportService.reportElements[element.index].value = str.replace(pattern, result[path[path.length - 1]]);
            },
            (err) => { console.log(err); }
          );
        }
      }
    });
  }
  pxToMm(px: any) {
    return Math.floor(parseInt(px) * 0.264583);
  }
  scaledValue(value: any, factor: any) {
    return Math.floor(value * factor);
  }
  unscaledValue(value: any, factor: any) {
    return Math.floor(value / factor);
  }
  decScale() {
    if (this.scale > 0) {
      this.scale--;
    }
  }
  incScale() {
    if (this.scale < this.scales.length - 1) {
      this.scale++;
    }
  }
  decPage() {
    if (this.page > 1) {
      this.page--;
      this.goTo(this.pages[this.page - 1].name);
    }
  }
  incPage() {
    if (this.page < this.pages.length) {
      this.page++;
      this.goTo(this.pages[this.page - 1].name);
    }
  }
  getHeight() {
    let height = 0;
    const size = _.findWhere(this.sizes, { id: this.sizeId });
    const orientation = _.findWhere(this.orientations, { id: this.orientationId });
    if (orientation && size) {
      if (orientation.uid == 1) {
        height = size.height;
      } else {
        height = size.width;
      }
      height = this.scaledValue(height, this.scales[this.scale].factor);
    }
    return height;
  }
  getWidth() {
    let width;
    const size = _.findWhere(this.sizes, { id: this.sizeId });
    const orientation = _.findWhere(this.orientations, { id: this.orientationId });
    if (orientation && size) {
      if (orientation.uid == 1) {
        width = size.width;
      } else {
        width = size.height;
      }
      width = this.scaledValue(width, this.scales[this.scale].factor);
    }
    return width;
  }
  getPaddingTop() {
    let paddingTop;
    const margin = _.findWhere(this.margins, { id: this.marginId });
    if (margin != null) {
      paddingTop = this.scaledValue(margin.margintop, this.scales[this.scale].factor);
    }
    return paddingTop;
  }
  getPaddingBottom() {
    let paddingBottom;
    const margin = _.findWhere(this.margins, { id: this.marginId });
    if (margin != null) {
      paddingBottom = this.scaledValue(margin.marginbottom, this.scales[this.scale].factor);
    }
    return paddingBottom;
  }
  getPaddingLeft() {
    let paddingLeft;
    const margin = _.findWhere(this.margins, { id: this.marginId });
    if (margin != null) {
      paddingLeft = this.scaledValue(margin.marginleft, this.scales[this.scale].factor);
    }
    return paddingLeft;
  }
  getPaddingRight() {
    let paddingRight;
    const margin = _.findWhere(this.margins, { id: this.marginId });
    if (margin != null) {
      paddingRight = this.scaledValue(margin.marginright, this.scales[this.scale].factor);
    }
    return paddingRight;
  }
  getTop(element: any) {
    let top;
    if (element.top != null) {
      top = element.top;
    }
    top = this.scaledValue(top, this.scales[this.scale].factor);
    return top;
  }
  getLeft(element: any) {
    let left;
    if (element.left != null) {
      left = element.left;
    }
    left = this.scaledValue(left, this.scales[this.scale].factor);
    return left;
  }
  goTo(id: any) {
    const page = document.getElementById(id);
    //page.parentNode.scrollTop = page.offsetTop;
  }
  dragElement($event: any) {
  }

  dropElement($event: any) {
    //let element: Element = $event.dragData;
    //element.setTop(this.unscaledValue(this.pxToMm($event.mouseEvent.offsetY), this.scales[this.scale].getFactor()));
    //element.setLeft(this.unscaledValue(this.pxToMm($event.mouseEvent.offsetX), this.scales[this.scale].getFactor()));
    //console.log($event);
  }

  /*report.openElement = function (element) {
    var url = 'template/reportelement';
    var pvModalInstance = modal.open(
      {
        animation: true,
        templateUrl: url,
        controller: ModalCtrl,
        controllerAs: 'modal',
        size: 'lg',
        backdrop: 'static',
        scope: scope,
        resolve: {
          param: function () {
            return { "data": element };
          }
        }
      });
    pvModalInstance.result.then(function (avItem) {
      if (avItem != null) {
        var pvValue = avItem.value;
        var pvId = avItem.id;
        report.value = pvId;
        report.displayedValue = pvValue;
      }
    },
      function (avItem) {
      });
  };*/
  over(row: number, col: number) {
    this.rowOver = row;
    this.colOver = col;
  }
  getTableBtnClass(row: number, col: number): string {
    let res: string = '';
    if (row <= this.rowOver && col <= this.colOver) {
      res = 'active';
    }
    return res;
  }
  addLabelElement() {
    if (this.model) {
      const reportElementType = _.findWhere(this.reportElementTypes, { uid: 1 });
      const reportElementSize = this.getLastReportElementSize();
      const fontFamily = this.getLastFontFamily();
      const fontSize = this.getLastFontSize();
      const textAlign = this.getLastTextAlign();
      if (reportElementType) {
        const labelElement = new Element(reportElementType.id, reportElementSize.id, 111, 'Element' + this.reportService.reportElements.length, 'Element ' + + this.reportService.reportElements.length, + this.reportService.reportElements.length, textAlign.id, fontFamily.id, fontSize.id, this.lastBold, this.lastItalic, this.lastUnderline, this.lastLineThrough, 111, 111);
        this.reportService.reportElements.push(labelElement);
      }
    }
  }
  addTableElement(row: number, col: number) {
    if (this.model) {
      const reportElementType = _.findWhere(this.reportElementTypes, { uid: 3 });
      const reportElementSize = this.getLastReportElementSize();
      const fontFamily = this.getLastFontFamily();
      const fontSize = this.getLastFontSize();
      const textAlign = this.getLastTextAlign();
      if (reportElementType) {
        const tableElement = new Element(reportElementType.id, reportElementSize.id, 111, 'Element' + this.reportService.reportElements.length, 'Element ' + + this.reportService.reportElements.length, + this.reportService.reportElements.length, textAlign.id, fontFamily.id, fontSize.id, false, false, false, false, 111, 111);
        const reportElementTypeRow = _.findWhere(this.reportElementTypes, { uid: 5 });
        let tableRowElement;
        const reportElementTypeCol = _.findWhere(this.reportElementTypes, { uid: 4 });
        let tableColElement;
        if (reportElementTypeRow && reportElementTypeCol) {
          for (let rowIdx = 0; rowIdx <= row; rowIdx++) {
            tableRowElement = new Element(reportElementTypeRow.id, reportElementSize.id, 111, 'Element' + tableElement.elements.length, 'Element ' + + tableElement.elements.length, + tableElement.elements.length, textAlign.id, fontFamily.id, fontSize.id, false, false, false, false, 111, 111);
            for (let colIdx = 0; colIdx <= col; colIdx++) {
              tableColElement = new Element(reportElementTypeCol.id, reportElementSize.id, 111, 'Element' + tableRowElement.elements.length, 'Element ' + + tableRowElement.elements.length, + tableRowElement.elements.length, textAlign.id, fontFamily.id, fontSize.id, false, false, false, false, 111, 111);
              tableRowElement.elements.push(tableColElement);
            }
            tableElement.elements.push(tableRowElement);
          }
          this.reportService.reportElements.push(tableElement);
        }
      }
      //this.popOverTable.close();
      this.rowOver = 0;
      this.colOver = 0;
    }
  }
  addImageElement() {
    if (this.model) {
      const reportElementType = _.findWhere(this.reportElementTypes, { uid: 6 });
      const reportElementSize = this.getLastReportElementSize();
      const fontFamily = this.getLastFontFamily();
      const fontSize = this.getLastFontSize();
      const textAlign = this.getLastTextAlign();
      if (reportElementType) {
        const imageElement = new Element(reportElementType.id, reportElementSize.id, 111, 'Element' + this.reportService.reportElements.length, '', + this.reportService.reportElements.length, textAlign.id, fontFamily.id, fontSize.id, false, false, false, false, 111, 111);
        this.reportService.reportElements.push(imageElement);
      }
    }
  }

  deleteElement() {
    this.reportService.deletedReportElements.push(this.selectedElement);
    this.reportService.reportElements.splice(this.selectedElement.index, 1);
    this.reindexElements();
    //this.selectedElement = undefined; TODO
  }

  incIndex() {
    const element = this.selectedElement;
    this.reportService.reportElements[this.selectedElement.index] = this.reportService.reportElements[this.selectedElement.index + 1];
    this.reportService.reportElements[this.selectedElement.index + 1] = element;
    this.reindexElements();
  }

  decIndex() {
    const element = this.selectedElement;
    this.reportService.reportElements[this.selectedElement.index] = this.reportService.reportElements[this.selectedElement.index - 1];
    this.reportService.reportElements[this.selectedElement.index - 1] = element;
    this.reindexElements();
  }

  reindexElements() {
    let index = 0;
    this.reportService.reportElements.forEach((reportElement) => {
      reportElement.index = index;
      index = index + 1;
    });
  }

  alignElement(uid: number) {
    const textAlign = _.findWhere(this.textAligns, { uid });
    if (textAlign) {
      this.selectedElement.textalign_id = textAlign.id;
      this.lastTextAlignId = textAlign.id;
    }
  }
  isAlignElement(uid: number): boolean {
    const textAlign = _.findWhere(this.textAligns, { uid });
    let isAligned: boolean = false;
    if (textAlign && this.selectedElement.textalign_id == textAlign.id) {
      isAligned = true;
    }
    return isAligned;
  }
  boldElement() {
    this.selectedElement.bold = !this.selectedElement.bold;
    this.lastBold = this.selectedElement.bold;
  }
  isBold(): boolean {
    return this.selectedElement.bold;
  }
  italicElement() {
    this.selectedElement.italic = !this.selectedElement.italic;
    this.lastItalic = this.selectedElement.italic;
  }
  isItalic(): boolean {
    return this.selectedElement.italic;
  }
  underlineElement() {
    this.selectedElement.underline = !this.selectedElement.underline;
    this.lastUnderline = this.selectedElement.underline;
    if (this.selectedElement.underline) {
      this.selectedElement.line_through = false;
      this.lastLineThrough = false;
    }
  }
  isUnderline(): boolean {
    return this.selectedElement.underline;
  }
  lineThroughElement() {
    this.selectedElement.line_through = !this.selectedElement.line_through;
    this.lastLineThrough = this.selectedElement.line_through;
    if (this.selectedElement.line_through) {
      this.selectedElement.underline = false;
      this.lastUnderline = false;
    }
  }
  isLineThrough(): boolean {
    return this.selectedElement.line_through;
  }
  colorFont() {
    if (this.selectedElement.fontcolor_id >= 1000) {
      this.selectedElement.fontcolor_id = 111;
    } else {
      this.selectedElement.fontcolor_id = this.lastFontColor.id;
    }
  }
  isFontColored(): boolean {
    return this.selectedElement.fontcolor_id >= 1000;
  }
  colorBackground() {
    if (this.selectedElement.backgroundcolor_id >= 1000) {
      this.selectedElement.backgroundcolor_id = 111;
    } else {
      this.selectedElement.backgroundcolor_id = this.lastBackgroundColor.id;
    }
  }
  isBackgroundColored(): boolean {
    return this.selectedElement.backgroundcolor_id >= 1000;
  }
  selectElement(element: Element) {
    this.selectedElement = element;
    setTimeout(() => {
      $('.mdb-select').material_select('destroy');
      $('.mdb-select').material_select();
      $('.mdb-select-fontfamily').on('change', function (this: any, $event: any) {
      }, ($event: any) => {
        this.onFontFamilyChange($event);
      });
      $('.mdb-select-fontsize').on('change', function (this: any, $event: any) {
      }, ($event: any) => {
        this.onFontSizeChange($event);
      });
      $('.mdb-select-reportelementsize').on('change', function (this: any, $event: any) {
      }, ($event: any) => {
        this.onReportElementSizeChange($event);
      });
    }, 50);
  }
  getLastReportElementSize(): ReportElementSize {
    let reportElementSize: any;
    if (this.lastReportElementSizeId >= 1000) {
      reportElementSize = _.findWhere(this.reportElementSizes, { id: this.lastReportElementSizeId });
    } else {
      reportElementSize = _.findWhere(this.reportElementSizes, { uid: 1 });
    }
    return reportElementSize;
  }
  getLastFontSize(): FontSize {
    let fontSize: any;
    if (this.lastFontSizeId >= 1000) {
      fontSize = _.findWhere(this.fontSizes, { id: this.lastFontSizeId });
    } else {
      fontSize = _.findWhere(this.fontSizes, { uid: 7 });
    }
    return fontSize;
  }
  getLastFontFamily(): FontFamily {
    let fontFamily: any;
    if (this.lastFontFamilyId >= 1000) {
      fontFamily = _.findWhere(this.fontFamilies, { id: this.lastFontFamilyId });
    } else {
      fontFamily = _.findWhere(this.fontFamilies, { uid: 1 });
    }
    return fontFamily;
  }
  getLastTextAlign(): TextAlign {
    let textAlign: any;
    if (this.lastTextAlignId >= 1000) {
      textAlign = _.findWhere(this.textAligns, { id: this.lastTextAlignId });
    } else {
      textAlign = _.findWhere(this.textAligns, { uid: 1 });
    }
    return textAlign;
  }
  getReportElementTypeUid(reportelementtype_id: number) {
    let reportElementTypeUid = 1;
    const reportElementType = _.findWhere(this.reportElementTypes, { id: reportelementtype_id });
    if (reportElementType) reportElementTypeUid = reportElementType.uid;
    return reportElementTypeUid;
  }
  onFontFamilyChange(e: any) {
    this.selectedElement.fontfamily_id = +e.target.value;
    this.lastFontFamilyId = +e.target.value;
  }
  onFontSizeChange(e: any) {
    this.selectedElement.fontsize_id = +e.target.value;
    this.lastFontSizeId = +e.target.value;
  }
  onReportElementSizeChange(e: any) {
    this.selectedElement.reportelementsize_id = +e.target.value;
    this.lastReportElementSizeId = +e.target.value;
  }
  getTextAlign(element: Element): string {
    let textAlign = 'left';
    if (element.textalign_id != null) {
      const textAlignElement = _.findWhere(this.textAligns, { id: element.textalign_id });
      if (textAlignElement) switch (textAlignElement.uid) {
        case 2: {
          textAlign = 'center';
          break;
        }
        case 3: {
          textAlign = 'right';
          break;
        }
        case 4: {
          textAlign = 'justify';
          break;
        }
        default: {
          break;
        }
      }
    }
    return textAlign;
  }
  getReportElementSizeClass(element: Element): string {
    let reportElementSizeClass = '';
    if (element.reportelementsize_id != null) {
      const reportElementSize = _.findWhere(this.reportElementSizes, { id: element.reportelementsize_id });
      if (reportElementSize) reportElementSizeClass = 'col-' + (13 - reportElementSize.uid);
    }
    return reportElementSizeClass;
  }
  getFontWeight(element: Element): string {
    let fontWeight = 'normal';
    if (element.bold) {
      fontWeight = 'bold';
    }
    return fontWeight;
  }
  getFontStyle(element: Element): string {
    let fontStyle = 'normal';
    if (element.italic) {
      fontStyle = 'italic';
    }
    return fontStyle;
  }
  getTextDecoration(element: Element): string {
    let textDecoration = 'none';
    if (element.underline) {
      textDecoration = 'underline';
    } else if (element.line_through) {
      textDecoration = 'line-through';
    }
    return textDecoration;
  }
  getFontFamily(element: Element): string {
    const fontFamilyElement = _.findWhere(this.fontFamilies, { id: element.fontfamily_id });
    let fontFamily = '';
    if (fontFamilyElement) fontFamily = fontFamilyElement.name.toLowerCase();
    return fontFamily;
  }
  getFontSize(element: Element): number {
    const fontSizeElement = _.findWhere(this.fontSizes, { id: element.fontsize_id });
    let fontSize = 0;
    if (fontSizeElement) fontSize = this.scaledValue(fontSizeElement.value, this.scales[this.scale].factor);
    return fontSize;
  }
  getFontColor(element: Element): string {
    let fontColor = 'black';
    if (element.backgroundcolor_id >= 1000) {
      const fontColorElement = _.findWhere(this.colors, { id: element.fontcolor_id });
      if (fontColorElement) fontColor = '#' + fontColorElement.hex;
    }
    return fontColor;
  }
  getBackgroundColor(element: Element): string {
    let backgroundColor = 'transparent';
    if (element.backgroundcolor_id >= 1000) {
      const backgroundColorElement = _.findWhere(this.colors, { id: element.backgroundcolor_id });
      if (backgroundColorElement) backgroundColor = '#' + backgroundColorElement.hex;
    }
    return backgroundColor;
  }

  displayLeftBar() {
    console.log('displayLeftBar');
  }
  search() {
    console.log('search');
  }
  print() {
    const w = window.open('http://pdf.odusseuserp.org/' + this.id);
    w.print();
  }

}
